import {BASE_URL} from "../../config/network";

const searchLocationAPI = async ({lat, lng, vehicleType, rentTypes = []}) => {

    const params = new URLSearchParams({
        lat: String(lat),
        lng: String(lng),
        vehicleType: String(vehicleType)
    })

    if (Array.isArray(rentTypes)) {
        rentTypes
            .filter(Boolean)
            .forEach((rentType) => params.append('rentTypes[]', String(rentType)))
    }

    const URL = `${BASE_URL}/public/location/search_2?${params.toString()}`
    const METHOD = "GET"
    const HEADERS = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }

    console.log("GET Search location")

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS
    })

    if (!response.ok) {
        console.log("GET Search address ERROR")
        throw new Error(`HTTP error: ${response.status}`)
    }

    return await response.json()
}

export {searchLocationAPI}
